import "antd/dist/antd.min.css";
import { Collapse, Slider, Button, Checkbox, Space } from "antd";
import React, { useState, useEffect } from "react";
import APIService from "../services/APIService";
import { Link, useParams, useSearchParams } from "react-router-dom";
import SImage from "./SImage";
const { Panel } = Collapse;



export default function LeftMenu({onChange, all = false }) {
  const [listCategory, setListCategory] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const cateId = searchParams.get("cateId");
  const [banner, setBanner] = useState([])
  let params = useParams();

  const renderRowMenu = (row) => {
    if (row.children) {
      return (
        <Collapse
          bordered={false}
          expandIconPosition="end"
          className="site-collapse-custom-collapse"
        >
          <Panel
            header={row.name}
            key="1"
            className="text-white site-collapse-custom-panel"
          >
            {row.children.map((item) => (
              <p className="py-3 text-left-menu">{item.name}</p>
            ))}
          </Panel>
        </Collapse>
      );
    } else {
      return (
        <button className="w-full" onClick={() => onChange(row.id)}>
          <p className={`px-4 py-3 text-left font-bold  hover:bg-white hover:text-main-blue ${cateId == row.id ? `bg-white text-black` : `text-white`}` }>{row.name}</p>
        </button>
      )
    }
  };

  async function getListBanner() {
    const RESULT = await APIService.getListBanner("category");
    if (RESULT) {
      setBanner(RESULT.qc_middle);
    }
  }
  async function getListCategory() {
    const RESULT = await APIService.getListCategory();
    if (RESULT) {
      if(all) {
        RESULT.unshift({id: 0, name: 'Tất cả'})
      }
      setListCategory(RESULT);
    }
  }

  useEffect(() => {
    getListCategory();
    getListBanner()
  }, []);

  return (
    <div className="sm:w-[280px] w-full">
      <div className=" bg-main-blue w-[content] sm:h-[410px] h-[270px] overflow-scroll">
        {listCategory.map((item) => renderRowMenu(item))}
      </div>
      <div className="p-3 mt-5 bg-white rounded-xl sm:block hidden">
        {banner.map((item) => (
          <SImage src={item.url} className="w-full" alt="" />
        ))}

      </div>
    </div>
  );
}
